export default __webpack_public_path__ + "static/media/Stokes.325aba10.jpg";